<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path v-for="(path, index) in paths" :key="index" :d="path" /></svg>
</template>
<script>
const icons = {
  arrow: ['M5 12h14m-5-5 5 5-5 5'],
  diagonal: ['M6 18 18 6M6 6h12v12'],
  ticket: ['M4 5h16v5a2 2 0 0 0 0 4v5H4v-5a2 2 0 0 0 0-4V5Z', 'M15 5v3m0 3v2m0 3v3'],
  calendar: ['M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z', 'M8 3v4m8-4v4M4 10h16'],
  chart: ['M4 4v16h16M8 16v-4m5 4V8m5 8V5'],
  plus: ['M12 5v14M5 12h14'],
  check: ['m5 12 4 4L19 6'],
  close: ['m6 6 12 12M6 18 18 6'],
  clock: ['M12 8v5l3 2', 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'],
  shield: ['m12 3 8 3v6c0 4-8 9-8 9s-8-5-8-9V6l8-3Z', 'm8 12 3 3 5-5'],
  chevron: ['m9 5 7 7-7 7'],
  down: ['m6 9 6 6 6-6'],
  spark: ['m12 3 2.4 6.6L21 12l-6.6 2.4L12 21l-2.4-6.6L3 12l6.6-2.4L12 3Z'],
  globe: ['M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z', 'M3 12h18M12 3c5 5 5 13 0 18-5-5-5-13 0-18Z'],
  search: ['M16 10a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z', 'm15 15 6 6'],
  menu: ['M4 7h16M4 12h16M4 17h16'],
  help: ['M9 8a3 3 0 0 1 6 1c0 2-3 2-3 4m0 3v.1', 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'],
  wallet: ['M20 8H4V5h14v3M4 8v12h16V8M20 12h-5v4h5'],
  lock: ['M7 10V7a5 5 0 0 1 10 0v3', 'M5 10h14v11H5V10Zm7 5v2'],
  refresh: ['M20 7v5h-5M4 17v-5h5', 'M5 8a8 8 0 0 1 14-2l1 2M4 16l1 2a8 8 0 0 0 14-2'],
}
export default { name: 'GoIcon', props: { name: { type: String, default: 'ticket' }, size: { type: [Number, String], default: 20 } }, computed: { paths() { return icons[this.name] || icons.ticket } } }
</script>
